<template>
  <div class="item">
    <img
      loading="lazy"
      :src="files + item.img + '?resize=1&w=600'"
      :alt="item.title"
      class="d-block item-img"
    />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 1 / 1;
    border: 1px solid #dddddd;
    border-radius: 4px;
    cursor: pointer;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
}
</style>
